import { ComputedStaticTextInput } from '@framework/form';
import Decimal from 'decimal.js-light';
import * as React from 'react';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import {
  MapCadastralAreaItem,
  MapCadastralAreaSuffix,
  MapCadastralSuffix,
} from '../../createMapSchema';
import { formatMapUnit } from '../../layers/rendering/MapUnitRender';

export interface IMapComputedTotalCadastralAffectedAreaProps {
  name: string;
  readonly?: boolean;
}

export function getComputedTotalCadastralAffectedArea(
  items: MapCadastralAreaItem[] | null | undefined,
) {
  return (
    items
      ?.reduce((sum, item) => sum.plus(item?.affectedArea ?? 0), new Decimal(0))
      ?.toNumber() ?? 0
  );
}

export function MapComputedTotalCadastralAffectedArea(
  props: IMapComputedTotalCadastralAffectedAreaProps,
) {
  const { name, readonly } = props;
  const cadastralItemsName = `${name}${MapCadastralSuffix}`;
  const cadastralAreaName = `${name}${MapCadastralAreaSuffix}`;

  const items: MapCadastralAreaItem[] | null = useWatch({
    name: cadastralItemsName,
  });

  const totalArea = useMemo(
    () => getComputedTotalCadastralAffectedArea(items ?? []),
    [items],
  );

  return (
    <ComputedStaticTextInput
      name={cadastralAreaName}
      value={totalArea ?? 0}
      removeBorder
      readonly={readonly}
      format={formatMapUnit}
    />
  );
}
